import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import Input from 'common/components/form/Input'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'

const DialogEditAvancement = ({
    open,
    ticket,
    onClose = () => {},
    onValidate = () => {},
}) => {
    const [avancement, setAvancement] = useState(ticket?.avancement)
    return (
        <Dialog open={open} onClose={onClose}>
            <BasicDialogTitle onClose={onClose}>
                {`Modifier l'avancement du ticket ${ticket?.id}`}
            </BasicDialogTitle>
            <DialogContent>
                <Input
                    label='Avancement (%)'
                    type='int'
                    value={avancement}
                    onChange={setAvancement}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        onValidate(avancement)
                        onClose()
                    }}
                    variant='contained'
                    color='primary'
                >
                    Valider
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogEditAvancement.propTypes = {
    open: PropTypes.bool,
    ticket: PropTypes.shape({
        id: PropTypes.number,
        avancement: PropTypes.number,
    }),
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
}

export default DialogEditAvancement
